// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorComponent_container__2Au4z","title":"ErrorComponent_title__1bmgd","subtitle":"ErrorComponent_subtitle__2Q5FX","message":"ErrorComponent_message__Df8OK"};